import { SkyLoader } from "@skypointcloud/skypoint-ui";
import { Styles } from "./SkypointLogoLoader.styles";

const SkypointLogoLoader = () => {
  return (
    <>
      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
      <div style={Styles.wrapper}>
        <div style={Styles.logoContainer}>
          <img
            src="/dist/img/skySupport-logo.png"
            alt="skySupport Logo"
            style={Styles.logoImage}
          />
        </div>

        <div style={Styles.loaderWrapper}>
          <SkyLoader label="Loading..." />
        </div>

        <div style={Styles.poweredByWrapper}>
          <span className="font-bold text-sm">Powered by</span>
          <img
            src="/dist/img/skyPoint-logo-text-black.svg"
            style={Styles.poweredByImage}
            alt="Skypoint"
          />
        </div>
      </div>
    </>
  );
};

export default SkypointLogoLoader;
